import * as React from 'react';
import {useCallback, useState} from 'react';
import {useIonAlert} from '@ionic/react';

import {AutoPayPage} from '../components';
import {useCustomerStore} from '../../../../redux/customers';
import {useToastStore} from '../../../../redux/toast';
import {customersService} from '../../../../services';
import {clearCache} from '../../../../services/api/responseCache';

type Props = {};

export const AutoPayPageContainer: React.FC<Props> = () => {
    const customerStore = useCustomerStore();
    const {activeCustomer, isFetching, getAll} = customerStore;
    const toastStore = useToastStore();
    const [presentConfirmAlert] = useIonAlert();
    const [isCancelling, setIsCancelling] = useState(false);

    const handleCancelConfirmed = useCallback(() => {
        if (!activeCustomer) {
            return;
        }
        setIsCancelling(true);
        customersService.cancelAutoPay(activeCustomer.id)
            .then(() => {
                // The customers GET is cached for 30s — drop it so the refetch
                // below can't serve the pre-cancel autoPay state back.
                clearCache();
                return getAll();
            })
            .then(() => {
                toastStore.showSuccess({message: 'Auto-pay cancelled.'});
            })
            .catch(() => {
                toastStore.showError({message: 'Failed to cancel auto-pay. Please try again.'});
            })
            .finally(() => {
                setIsCancelling(false);
            });
    }, [activeCustomer, getAll, toastStore]);

    const handleCancel = useCallback(() => {
        presentConfirmAlert({
            header: 'Cancel Auto-pay',
            message: 'Are you sure you want to cancel auto-pay? Your card will no longer be charged automatically.',
            buttons: [
                {
                    text: 'Nope',
                    role: 'cancel',
                    handler: () => {
                    },
                },
                {
                    text: 'Yes, Cancel',
                    role: 'confirm',
                    handler: handleCancelConfirmed,
                },
            ],
        });
    }, [presentConfirmAlert, handleCancelConfirmed]);

    return (
        <AutoPayPage
            customer={activeCustomer}
            isFetching={isFetching}
            isCancelling={isCancelling}
            onCancel={handleCancel}
        />
    );
};
